import type { SetRequiredAndNonNullable } from '@festina-life/core'
import type { FPlusViewerAlignment } from '@festina-life/fplus'
import cx from 'classnames'
import type { Ref } from 'react'

import { LiteralExpressionItem } from './LiteralExpressionItem'
import { LiteralExpressionListViewer } from './LiteralExpressionListViewer'
import type { LiteralTypeInformation } from './types'

type Props = {
  typeInformation: SetRequiredAndNonNullable<LiteralTypeInformation, 'value'>
  alignment: FPlusViewerAlignment
  className?: string
  ref?: Ref<HTMLDivElement>
}

export const LiteralExpressionViewer = ({
  alignment,
  typeInformation,
  className,
  ref,
}: Props) => (
  <div
    ref={ref}
    data-testid="simpleViewer"
    className={cx('text-wrap break-all', className)}
  >
    {typeInformation.collectionType ? (
      <LiteralExpressionListViewer
        alignment={alignment}
        typeInformation={typeInformation}
      />
    ) : (
      <LiteralExpressionItem
        alignment={alignment}
        item={typeInformation.value.at(0) ?? ''}
        type={typeInformation.literalType}
      />
    )}
  </div>
)
